import React, { useState } from 'react';
import styled from 'styled-components';
import StoreItem from './StoreItem';
// import store from '../db/store.json';

const StoreWrapper = styled.div`
  box-sizing: border-box;
  padding-bottom: 5rem;

  @media screen and (max-width: 1199px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const StoreContainer = styled.div`
  padding-top: 2.5rem;
`;

const StoreTitle = styled.h3`
  padding-bottom: 0.625rem;
  margin-bottom: 1.875rem;
  border-bottom: 2px solid #1c92c1;
  font-size: 1.125rem;
  font-weight: bold;
  color: #1c92c1;

  @media screen and (max-width: 499px) {
    padding-bottom: 0.75rem;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #1c92c1;
    font-size: 1rem;
  }
`;

const StoreList = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 3.75rem 0;

  @media screen and (max-width: 499px) {
    gap: 1.5rem 0;
  }
`;

const Store = ({ store, keyword, typename }) => {
  return (
    <>
      {keyword.length < 2 ? (
        <StoreWrapper>
          {(typename === '전체' || typename === '') && (
            <>
              <StoreContainer>
                <StoreTitle>냉동수산부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '냉동수산부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
              <StoreContainer>
                <StoreTitle>패류부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '패류부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
              <StoreContainer>
                <StoreTitle>선어도매부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '선어도매부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
              <StoreContainer>
                <StoreTitle>건어부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '건어부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
              <StoreContainer>
                <StoreTitle>젓갈부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '젓갈부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
            </>
          )}
          {typename === '냉동수산부' && (
            <>
              <StoreContainer>
                <StoreTitle>냉동수산부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '냉동수산부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
            </>
          )}
          {typename === '패류부' && (
            <>
              <StoreContainer>
                <StoreTitle>패류부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '패류부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
            </>
          )}
          {typename === '선어도매부' && (
            <>
              <StoreContainer>
                <StoreTitle>선어도매부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '선어도매부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
            </>
          )}
          {typename === '건어부' && (
            <>
              <StoreContainer>
                <StoreTitle>건어부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '건어부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
            </>
          )}
          {typename === '젓갈부' && (
            <>
              <StoreContainer>
                <StoreTitle>젓갈부</StoreTitle>
                <StoreList>
                  {store.map(
                    (v, i) =>
                      v.type === '젓갈부' && (
                        <StoreItem props={v} key={v.domain} />
                      ),
                  )}
                </StoreList>
              </StoreContainer>
            </>
          )}
        </StoreWrapper>
      ) : (
        <StoreWrapper>
          {
            <StoreContainer>
              <StoreTitle>검색 상점</StoreTitle>
              <StoreList>
                {store.map((v, i) => (
                  <StoreItem props={v} key={v.domain} />
                ))}
              </StoreList>
            </StoreContainer>
          }
        </StoreWrapper>
      )}
    </>
  );
};

export default Store;
